var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    cell: true,
    'map-node': true,
    selected: _vm.node.selected,
    wide: _vm.isSelectedColumn,
    collapsed: _vm.x >= _vm.collapseRange[0] && _vm.x <= _vm.collapseRange[1]
},attrs:{"data-node-id":_vm.node.nodeId}},[(_vm.node.title)?_c('div',{class:{
        content: true,
        node: true,
        connected: _vm.nodeToTheRight && _vm.nodeToTheRight.connector,
        active: _vm.activePath
    }},[_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.clickNode}},[(_vm.y > 0)?_c('div',{class:{
                'v-up': true,
                active: _vm.node.selected
            }}):_vm._e(),_c('span',[_c('strong',[_vm._v(_vm._s(_vm.node.title))])]),_c('div',{staticClass:"steps"},_vm._l((_vm.node.checklist),function(step,si){return _c('span',{key:'step-' + _vm.node.id + '-' + si,class:step.state})}),0),(_vm.node.children && _vm.node.children.length > 0)?_c('div',{class:{
                'v-down': true,
                'active': _vm.anySelectedChildren
            }}):_vm._e(),_c('div',{staticClass:"position"}),_c('div',{class:{
                l: true,
                active: _vm.nodeBelow && _vm.nodeBelow.selected
            }}),(_vm.node.children && _vm.node.selectedChildIndex !== (_vm.node.children.length - 1))?_c('div',{class:{
                    r: true,
                    active: _vm.node.toTheRightSelected
            }}):_vm._e()])]):(_vm.node.connector)?_c('div',{class:_vm.nodeClass},[_c('div',{class:{
                l: true,
                active: _vm.nodeBelow && _vm.nodeBelow.selected
            }}),_c('div',{staticClass:"r"}),_c('div',{staticClass:"v"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }